import * as Sentry from "@sentry/react";
import { initialOptions } from "@common/sentry/initialOptions";
export var initSentry = function() {
    if (process.env.NEXT_PUBLIC_SENTRY_ENABLED === "1") {
        // see: https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/
        Sentry.init(initialOptions);
    }
};
